import { useBetween } from 'use-between';
import { CompanySettingsUseBetween } from '../shared/use-between/company-settings-use-between';
import { DECIMAL_SEPARATOR_COMMA } from '../shared/constants/decimal-separator.constants';
import {
    getPriceWithPrecision,
    getNetPriceWithPrecision,
    calculateTotalPricePerProduct,
} from '../components/shopping-cart/services/shopping-cart.service';

export const applyDecimalSeparator = (formattedNumber: string, decimalSeparator?: string): string => {
    return decimalSeparator === DECIMAL_SEPARATOR_COMMA ? formattedNumber.replace('.', ',') : formattedNumber;
};

// Wraps the plain, dot-only price formatters (still exported by shopping-cart.service for their
// rounding logic) with the company's decimal separator setting. The default (Dot) when the setting is
// missing/unrecognized is the API's responsibility (CompanySettingsService), not this hook's - the only
// case handled here is the brief window before the initial fetch resolves, where the shared state is
// still its empty initial value.
const usePriceFormatter = () => {
    const { companySettings } = useBetween(CompanySettingsUseBetween);
    const decimalSeparator = companySettings?.decimalSeparator;

    return {
        getPriceWithPrecision: (value: number) => applyDecimalSeparator(getPriceWithPrecision(value), decimalSeparator),
        getNetPriceWithPrecision: (value: number) =>
            applyDecimalSeparator(getNetPriceWithPrecision(value), decimalSeparator),
        calculateTotalPricePerProduct: (price: number, quantity: number, isDisabled: boolean) =>
            applyDecimalSeparator(
                calculateTotalPricePerProduct(price, quantity, isDisabled).toString(),
                decimalSeparator
            ),
    };
};

export default usePriceFormatter;
